import { Component, Input } from "@angular/core";

import { SearchResultItemModel } from "../../../models/search-result-item.model";

@Component({
    selector: "[pcg-ng-result-item]",
    templateUrl: "./result-item.component.html",
    providers: []
})
export class ResultItemComponent {

    @Input()
    public result: SearchResultItemModel = null;
}
